import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import dayjs from "dayjs";
import { getLeachingStationDetails } from "../ProductionLine/services";
import { toast } from "react-toastify";

const LeachingReport = ({ setLeachingPopup, batchId }) => {
  const [leachingData, setLeachingData] = useState([]);

  useEffect(() => {
    handleGetLeaching();
  }, [batchId]);

  const handleGetLeaching = async () => {
    try {
      const resp = await getLeachingStationDetails(batchId);
      if (resp.status == 200 || resp.status == 201) {
        setLeachingData(resp.data.payload);
      }
    } catch (error) {
      toast.error(error.response.data.message);
      setLeachingData([]);
      console.log("handlesubmit", error);
    }
  };

  return (
    <>
      <div className="modal-container" style={{ height: "40vh", top: "35vh" }}>
        <div className="modal-header">
          <div className="modal-title">Leaching PROCESS SHEET</div>
          <div
            onClick={() => setLeachingPopup(false)}
            style={{ cursor: "pointer" }}
          >
            <CloseIcon />
          </div>
        </div>
        <div className="modal-table-wrapper">
          <div
            style={{
              width: "100%",
              overflow: "auto",
              maxHeight: "400px",
            }}
            className="gloves-report-data"
          >
            <Table className="gloves-params">
              <TableHead>
                <TableRow>
                  <TableCell colSpan={2}>Cold leaching </TableCell>
                  <TableCell colSpan={2}>Cold leaching Water Level</TableCell>
                  <TableCell colSpan={2}>Hot leaching </TableCell>
                  <TableCell colSpan={2}>Hot leaching Water Level</TableCell>
                  <TableCell colSpan={3}>Hot Leaching</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Start Time</TableCell>
                  <TableCell>End Time </TableCell>
                  <TableCell>Min (Ltr)</TableCell>
                  <TableCell>Max (Ltr)</TableCell>
                  <TableCell>Start Time</TableCell>
                  <TableCell>End Time </TableCell>
                  <TableCell>Min (Ltr)</TableCell>
                  <TableCell>Max (Ltr)</TableCell>
                  <TableCell>Set Temp</TableCell>
                  <TableCell>Min Temp</TableCell>
                  <TableCell>Max Temp</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {leachingData?.map((e) => {
                  return (
                    <>
                      <TableRow>
                        <TableCell>
                          {e?.cold_leach_cycle_start_time
                            ? dayjs(e?.cold_leach_cycle_start_time).format(
                                "HH:mm:ss"
                              )
                            : "--"}
                        </TableCell>
                        <TableCell>
                          {e?.cold_leach_cycle_end_time
                            ? dayjs(e?.cold_leach_cycle_end_time).format(
                                "HH:mm:ss"
                              )
                            : "--"}
                        </TableCell>
                        <TableCell>
                          {e?.cold_leach_min_water_level || "--"}
                        </TableCell>
                        <TableCell>
                          {e?.cold_leach_max_water_level || "--"}
                        </TableCell>
                        <TableCell>
                          {e?.hot_leach_cycle_start_time
                            ? dayjs(e?.hot_leach_cycle_start_time).format(
                                "HH:mm:ss"
                              )
                            : "--"}
                        </TableCell>
                        <TableCell>
                          {e?.hot_leach_cycle_end_time
                            ? dayjs(e?.hot_leach_cycle_end_time).format(
                                "HH:mm:ss"
                              )
                            : "--"}
                        </TableCell>
                        <TableCell>
                          {e?.hot_leach_min_water_level || "--"}
                        </TableCell>
                        <TableCell>
                          {e?.hot_leach_max_water_level || "--"}
                        </TableCell>
                        <TableCell>{e?.hot_leach_set_temp || "--"}</TableCell>
                        <TableCell>{e?.hot_leach_min_temp || "--"}</TableCell>
                        <TableCell>{e?.hot_leach_max_temp || "--"}</TableCell>
                      </TableRow>
                    </>
                  );
                })}
              </TableBody>
            </Table>
          </div>
        </div>
      </div>
      <div
        className="modal-overlay"
        onClick={() => setLeachingPopup(false)}
      ></div>
    </>
  );
};

export default LeachingReport;
